function formatLabel(str, maxwidth) {
  var sections = []
  var words = str.split(" ")
  var temp = ""

  words.forEach(function (item, index) {
    if (temp.length > 0) {
      var concat = temp + " " + item

      if (concat.length > maxwidth) {
        sections.push(temp)
        temp = ""
      } else {
        if (index === words.length - 1) {
          sections.push(concat)
          return
        } else {
          temp = concat
          return
        }
      }
    }

    if (index === words.length - 1) {
      sections.push(item)
      return
    }

    if (item.length < maxwidth) {
      temp = item
    } else {
      sections.push(item)
    }
  })

  return sections
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

let optionsTrainingRegion = {
  height: "small",
  legend: {
    display: false,
  },
  maintainAspectRatio: false,
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
        var label = data.datasets[tooltipItem.datasetIndex].label || ""

        if (label) {
          label += ": "
        }

        label += parseFloat(tooltipItem.yLabel).toLocaleString()

        return label
      },
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 6000,
          maxTicksLimit: 4,
          callback: function (num) {
            return num > 1
              ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "K"
              : num
          },
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let optionsTrainingIncome = {
  height: "small",
  legend: {
    display: false,
  },
  maintainAspectRatio: false,
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
        var label = data.datasets[tooltipItem.datasetIndex].label || ""

        if (label) {
          label += ": "
        }

        label += parseFloat(tooltipItem.yLabel).toLocaleString()

        return label
      },
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 10000,
          maxTicksLimit: 8,
          callback: function (num) {
            return num > 1
              ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "K"
              : num
          },
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let optionsCDRegion = {
  height: "small",
  legend: {
    display: false,
  },
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 50,
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let optionsCDIncome = {
  height: "small",
  legend: {
    display: false,
  },
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 60,
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let optionsCDTopic = {
  height: "small",
  legend: {
    display: false,
  },
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 50,
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let chartData = [
  {
    id: "share-of-spending",
    data: {
      labels: [
        "Bilateral Surveillance",
        "Multilateral Surveillance",
        "Technical Assistance",
        "Training",
        "Oversight of Global Systems",
        "Lending",
        "Miscellaneous",
      ],
      datasets: [
        {
          data: [23.1, 19.1, 24.1, 4.7, 10.9, 14.8, 3.3],
          backgroundColor: [
            "#47812E",
            "#47812E",
            "#47812E",
            "#47812E",
            "#47812E",
            "#47812E",
            "#47812E",
            "#47812E",
          ],
          barThickness: 12,
        },
      ],
    },
    options: {
      legend: {
        display: false,
      },
      layout: {
        padding: {
          bottom: 10,
        },
      },
      scales: {
        yAxes: [
          {
            ticks: {
              callback: function (value, index, values) {
                return value + "%"
              },
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
      },
    },
  },
  {
    id: "spending-on-capacity-development",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          label: "IMF financed",
          borderColor: "#0084BC",
          backgroundColor: "#0084BC",
          data: [132, 138, 140, 139, 131],
          barThickness: 12,
        },
        {
          label: "Externally financed",
          borderColor: "#004171",
          backgroundColor: "#004171",
          data: [142, 173, 177, 166, 120],
          barThickness: 12,
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      height: "medium",
      scales: {
        xAxes: [
          {
            stacked: true,
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              callback: function (value, index, values) {
                return "$" + value
              },
            },
          },
        ],
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 10,
          padding: 20,
        },
      },
    },
  },
  {
    id: "capacity-africa",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [40.9, 37.9, 38.8, 38.9, 37.7],
          borderColor: "#004171",
          backgroundColor: "#004171",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-asia",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [16.7, 20.9, 24.2, 24.7, 22.2],
          borderColor: "#004171",
          backgroundColor: "#004171",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-europe",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [11.4, 10.6, 8.9, 8.6, 10.0],
          borderColor: "#004171",
          backgroundColor: "#004171",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-middle-east",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [14.6, 14.7, 13.9, 13.6, 14.3],
          borderColor: "#004171",
          backgroundColor: "#004171",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-western-hemisphere",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [16.5, 15.9, 14.1, 14.2, 15.8],
          borderColor: "#004171",
          backgroundColor: "#004171",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-income-advanced",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [3.0, 2.2, 2.3, 1.7, 2.7],
          borderColor: "#47812E",
          backgroundColor: "#47812E",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDIncome,
  },
  {
    id: "capacity-income-emerging",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [45.5, 47.4, 44.2, 44.9, 44.2],
          borderColor: "#47812E",
          backgroundColor: "#47812E",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDIncome,
  },
  {
    id: "capacity-income-low",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [50.2, 49.0, 52.0, 51.6, 51.0],
          borderColor: "#47812E",
          backgroundColor: "#47812E",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDIncome,
  },
  {
    id: "capacity-topic-public",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [41.5, 42.3, 42.5, 45.0, 46.1],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "capacity-topic-monetary",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [21.4, 21.3, 20.1, 18.8, 18.2],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "capacity-topic-statistics",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [12.3, 13.2, 12.9, 12.3, 11.5],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "capacity-topic-legal",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [5.5, 5.1, 4.5, 3.9, 4.0],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "capacity-topic-macroeconomic",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [15.0, 13.3, 14.8, 14.9, 14.0],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "training-advanced",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [784, 747, 853, 1055, 1095],
          borderColor: "#E36E26",
          backgroundColor: "#E36E26",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsTrainingIncome,
  },
  {
    id: "training-emerging",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [7295, 9184, 8800, 9284, 8329],
          borderColor: "#E36E26",
          backgroundColor: "#E36E26",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsTrainingIncome,
  },
  {
    id: "training-low-income",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [5520, 6283, 7015, 7015, 5160],
          borderColor: "#E36E26",
          backgroundColor: "#E36E26",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsTrainingIncome,
  },
  {
    id: "training-africa",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [4353, 4711, 4948, 4708, 4283],
          borderColor: "#0084BC",
          backgroundColor: "#0084BC",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
  {
    id: "training-asia",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [2504, 3674, 4284, 5089, 3434],
          borderColor: "#0084BC",
          backgroundColor: "#0084BC",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
  {
    id: "training-europe",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [1783, 1799, 1586, 1735, 1099],
          borderColor: "#0084BC",
          backgroundColor: "#0084BC",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
  {
    id: "training-middle-east",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [2831, 3523, 3402, 3310, 2443],
          borderColor: "#0084BC",
          backgroundColor: "#0084BC",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
  {
    id: "training-western-hemisphere",
    data: {
      labels: ["2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          data: [2354, 2889, 2773, 2884, 3667],
          borderColor: "#0084BC",
          backgroundColor: "#0084BC",
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
  {
    id: "course-participation",
    data: {
      labels: ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          label: "Course offerings by fiscal year",
          type: "bar",
          yAxesID: "y-axis-1",
          data: [2, 6, 13, 19, 22, 27, 44, 53],
          backgroundColor: "#0084BC",
          borderColor: "#0084BC",
          borderWidth: 1,
          order: 2,
        },
        {
          type: "line",
          label: "Total active participants",
          yAxisID: "y-axis-2",
          backgroundColor: "rgba(255,255,255,0.5)",
          data: [1296, 10622, 21922, 35620, 45796, 60173, 88951, 112904],
          borderColor: "#F1AF2A",
          borderWidth: 2,
          order: 1,
        },
      ],
    },
    options: {
      height: "medium",
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            id: "y-axis-1",
            position: "left",
            type: "linear",
            ticks: {
              beginAtZero: true,
            },
            scaleLabel: {
              display: true,
              labelString: "Course offerings",
            },
          },
          {
            id: "y-axis-2",
            position: "right",
            type: "linear",
            ticks: {
              max: 120000,
              stepSize: 20000,
              display: true,
              beginAtZero: true,
              callback: function (value, index, values) {
                if (parseInt(value) >= 1000) {
                  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                } else {
                  return value
                }
              },
            },
            scaleLabel: {
              display: true,
              labelString: "Active participants",
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 10,
          padding: 20,
        },
      },
    },
  },
  {
    id: "government-revenue-and-spending-measures",
    data: {
      labels: ["AEs", "EMs", "LIDCs", "Global"],
      datasets: [
        {
          label: "2020",
          borderColor: "#EC9E42",
          backgroundColor: "#EC9E42",
          data: [8.1, 3.4, 1.3, 5.2],
          barThickness: 12,
        },
        {
          label: "2021",
          borderColor: "#94B9C6",
          backgroundColor: "#94B9C6",
          data: [6, 0.5, 0.5, 2.8],
          barThickness: 12,
        },
        {
          label: "2022 & Beyond",
          borderColor: "#B4D05E",
          backgroundColor: "#B4D05E",
          data: [2.2, 0.1, 0, 1],
          barThickness: 12,
        },
      ],
    },
    options: {
      height: "medium",
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            stacked: true,
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              callback: function (value, index, values) {
                return value + "%"
              },
            },
          },
        ],
      },
      legend: {
        position: "top",
        align: "start",
        labels: {
          boxWidth: 10,
          padding: 15,
        },
      },
    },
  },
  {
    id: "selected-economic-indicators",
    data: {
      labels: [
        formatLabel(
          "Change in fiscal-balance-to-GDP ratio (in percentage points)",
          20
        ),
        formatLabel(
          "Discretionary fiscal response: Additional spending and foregone revenues¹ (percent of GDP)",
          20
        ),
      ],
      datasets: [
        {
          label: "Advanced economies",
          borderColor: "#B4D05E",
          backgroundColor: "#B4D05E",
          data: [-9.9, 24],
          barThickness: 12,
        },
        {
          label: "Emerging markets",
          borderColor: "#94B9C6",
          backgroundColor: "#94B9C6",
          data: [-5.5, 6.1],
          barThickness: 12,
        },
        {
          label: "PRGT/LICS",
          borderColor: "#EC9E42",
          backgroundColor: "#EC9E42",
          data: [-1.7, 1.8],
          barThickness: 12,
        },
      ],
    },
    options: {
      height: "medium",
      maintainAspectRatio: false,
      legend: {
        position: "top",
        align: "start",
        labels: {
          boxWidth: 10,
          padding: 15,
        },
      },
      tooltips: {
        callbacks: {
          title: function (tooltipItem, data) {
            let label = tooltipItem[0].label.replace(/,/g, "\n")
            return label
          },
        },
      },
    },
  },
  {
    id: "global-education",
    data: {
      labels: [
        formatLabel("All economies", 10),
        formatLabel("Advanced economies", 10),
        formatLabel("Emerging market economies", 10),
        formatLabel("Low-income developing countries", 10),
      ],
      datasets: [
        {
          data: [48.92, 15.02, 45.7, 68.86],
          borderColor: "#004171",
          backgroundColor: ["#004171", "#0084BC", "#0084BC", "#0084BC"],
          fill: false,
          barThickness: 12,
        },
      ],
    },
    options: {
      height: "medium",
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      tooltips: {
        callbacks: {
          title: function (tooltipItem, data) {
            let label = tooltipItem[0].label.replace(/,/g, " ")
            return label
          },
        },
      },
    },
  },
  {
    id: "donations-matching",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020", "2021"],
      datasets: [
        {
          label: "Employee and retiree donations ",
          borderColor: "#88CCEE",
          backgroundColor: "#88CCEE",
          data: [
            1176330.43, 1525001.79, 1655109.73, 1769461.91, 2013725.78,
            2269915.34,
          ],
          barThickness: 12,
        },
        {
          label: "Matching funds ",
          borderColor: "#44AA99",
          backgroundColor: "#44AA99",
          data: [
            584199.87, 792281.98, 932031.88, 1206417.56, 1614351.94, 1827136.17,
          ],
          barThickness: 12,
        },
      ],
    },
    options: {
      height: "large",
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            stacked: true,
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              callback: function (num) {
                return num > 1
                  ? "$" + Math.sign(num) * (Math.abs(num) / 1000000).toFixed(1)
                  : num
              },
            },
          },
        ],
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || ""

            if (label) {
              label += ": "
            }
            label += "$" + numberWithCommas(tooltipItem.yLabel)
            return label
          },
        },
      },
      legend: {
        position: "top",
        align: "start",
        labels: {
          boxWidth: 10,
          padding: 15,
        },
      },
    },
  },
]

export default chartData
